// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3CzLU","consentsList":"PatientConsents_consentsList__qs904","consentsListEmpty":"PatientConsents_consentsListEmpty__23Hbt"};